export default [
     {
          path: "/vulnerability",
          name: "Vulnerability",
          component: () => import("@/views/Page/Vulnerability/Vulnerability.vue"),
          meta: {
               title: "Vulnerability",
          },
     },
     {
          path: "/vulnerability-manager",
          name: "Vulnerability Manager",
          component: () =>
               import("@/views/Page/Vulnerability/VulnerabilityManager.vue"),
          meta: {
               title: "Vulnerability Manager",
               permission: "Vulnerability.vulnerabilityManager",
          },
     },
];
